import styled from "styled-components";

export const PackageDetailsWrapper = styled.div<{ isPadded: boolean }>`
  padding: ${({ isPadded }) => (isPadded ? "0 1.5em" : "0")};
`;
